import type { OgsmBoard, OgsmBoardNode } from '@/types/api'

/** `nodes` itself when shown; else the nodes the backend did not flag inactive. */
export function visibleNodes(
  nodes: OgsmBoardNode[],
  showInactive: boolean
): OgsmBoardNode[] {
  return showInactive ? nodes : nodes.filter((node) => !node.inactive)
}

/** Whether the title-row toggle has anything to do in this view (backend counts only). */
export function viewHasInactive(
  board: OgsmBoard,
  drilled: OgsmBoardNode | undefined
): boolean {
  return drilled
    ? drilled.strategiesInactive > 0 ||
        drilled.strategies.some((node) => node.strategiesInactive > 0)
    : board.objectives.some((node) => node.strategiesInactive > 0)
}
